import { Helmet } from 'react-helmet';

export default function SEO({ title, description }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content="Adrian Rudge, Full Stack Engineer, Portfolio, Systems Administrator, DevOps, Cybersecurity, .Net , C#, JavaScript, React, SQL" />
      <meta name="author" content="Adrian Rudge" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#10B981" />
      <link rel="icon" href="/favicon.ico" />

      {/* Open Graph (Facebook, LinkedIn, Discord) */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="/preview.png" />
      <meta property="og:url" content="https://www.adrianrudge.co.uk" />

      {/* Twitter preview (optional but recommended) */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content="/preview.png" />
    </Helmet>
  );
}
